import React from "react";
import styled from "styled-components";
import { tokens } from "../../theme/tokens";

// Toolbar — a filters/actions row that sits above a table or list. Holds a
// search field, filter selects, and right-aligned actions. Presentation-only.
//
//   <Toolbar>
//     <SearchInput value={q} onChange={...} placeholder="Search riders" />
//     <Select>...</Select>
//     <Toolbar.Spacer />
//     <Button>Export</Button>
//   </Toolbar>

const { colors, radii, spacing, typography, shadows, motion } = tokens;

const Root = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: ${spacing[3]};
    padding: ${spacing[3]} ${spacing[4]};
    background: ${colors.surface};
    border: 1px solid ${colors.border};
    border-radius: ${radii.md};
    box-shadow: ${shadows.xs};
    margin-bottom: ${spacing[4]};
`;

const Spacer = styled.div`
    flex: 1 1 auto;
`;

const SearchWrap = styled.div`
    position: relative;
    flex: 0 1 320px;
    min-width: 180px;
    svg {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        color: ${colors.muted};
        pointer-events: none;
    }
`;

const SearchField = styled.input`
    width: 100%;
    height: 40px;
    padding: 0 14px 0 36px;
    font-family: ${typography.fonts.body};
    font-size: ${typography.size.base};
    color: ${colors.body};
    background: ${colors.cream};
    border: 1.5px solid ${colors.border};
    border-radius: ${radii.pill};
    transition: border-color ${motion.fast} ${motion.ease}, box-shadow ${motion.fast} ${motion.ease},
        background ${motion.fast} ${motion.ease};
    &::placeholder { color: ${colors.faint}; }
    &:focus {
        outline: none;
        border-color: ${colors.primary};
        background: ${colors.surface};
        box-shadow: ${shadows.focus};
    }
`;

export function SearchInput({ value, onChange, placeholder = "Search…", ...rest }) {
    return (
        <SearchWrap>
            <svg viewBox="0 0 20 20" fill="none" aria-hidden>
                <circle cx="9" cy="9" r="6" stroke="currentColor" strokeWidth="1.8" />
                <path d="m14 14 3 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
            <SearchField value={value} onChange={onChange} placeholder={placeholder} {...rest} />
        </SearchWrap>
    );
}

export default function Toolbar({ children, ...rest }) {
    return <Root {...rest}>{children}</Root>;
}

Toolbar.Spacer = Spacer;
